
import { mixins } from 'vue-class-component'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

import mixin from './mixin'
import itemMixin from './item-mixin'
import { findNodeUpperByClasses } from '@/libs/util'

@Component
export default class CollapsedMenu extends mixins(mixin, itemMixin) {
    @Prop({ default: false }) readonly hideTitle!: boolean
    @Prop({ default: 16 }) readonly rootIconSize!: number

    name = 'CollapsedMenu'
    placement = 'right-end'

    @Emit('on-click')
    handleClick(name) {
        return name
    }

    handleMousemove(event, children) {
        const { pageY } = event
        const height = children.length * 38
        const isOverflow = pageY + height < window.innerHeight
        this.placement = isOverflow ? 'right-start' : 'right-end'
    }

    mounted() {
        let dropdown = findNodeUpperByClasses((this.$refs.dropdown as Vue).$el, ['ivu-select-dropdown', 'ivu-dropdown-transfer'])
        if (dropdown) dropdown.style.overflow = 'visible'
    }
}
